module.exports = __webpack_public_path__ + "static/media/likesofus.aa76d67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/likesofus.png
// module id = 143
// module chunks = 0